import React from 'react'
import { useTranslation } from 'react-i18next'
import ControlsTooltipWrapper from '../ControlsTooltipWrapper'
import { ZoomContainer, ZoomButtonContainer } from './ZoomStyles'

interface ZoomButtonProps {
  onClick: () => void
  children: React.ReactNode
  disabled?: boolean
  position: 'top' | 'bottom'
  mapsView: string
}

const ZoomButton: React.FC<ZoomButtonProps> = ({ onClick, children, disabled = false, position, mapsView }) => {
  return (
    <ZoomButtonContainer
      disabled={disabled}
      position={position}
      mapsView={mapsView}
      onClick={disabled ? undefined : onClick}
    >
      {children}
    </ZoomButtonContainer>
  )
}

interface ZoomProps {
  onZoomIn: () => void
  onZoomOut: () => void
  mapsView: string
  disabled?: boolean
}

const Zoom: React.FC<ZoomProps> = ({ onZoomIn, onZoomOut, mapsView, disabled = false }) => {
  const { t } = useTranslation()
  return (
    <ZoomContainer
      className={mapsView !== 'building' ? 'globalsite' : ''}
    >
      <ControlsTooltipWrapper title={t('cartography.maps.controls.zoom_in')}>
        <ZoomButton onClick={onZoomIn} disabled={disabled} position="top" mapsView={mapsView}>
          +
        </ZoomButton>
      </ControlsTooltipWrapper>
      <ControlsTooltipWrapper title={t('cartography.maps.controls.zoom_out')}>
        <ZoomButton onClick={onZoomOut} disabled={disabled} position="bottom" mapsView={mapsView}>
          −
        </ZoomButton>
      </ControlsTooltipWrapper>
    </ZoomContainer>
  )
}

export default Zoom